import PlatformApi from '@/services/platform-user';
import baseUtils from '@/utils/baseUtils';

const platformUser = {
    state: {
        platformUserId: '',
        platformToken: '',
        platformUserData: {},
    },
    mutations: {
    //设置登录后的信息
    SET_PLATFORM_AUTH_USER_META: (state, data) => {
        //console.log('SET_PLATFORM_AUTH_USER_META:'+JSON.stringify(data))
        if (data) {
            state.platformUserId = data.platformUserId;
            state.platformToken = data.platformToken;
            console.log('登录成功后设置Token:'+state.platformToken)
            state.platformUserData = data;
            localStorage.setItem('platformUserId', data.platformUserId);
            localStorage.setItem('platformToken', data.platformToken);
            localStorage.setItem('platformUserData', JSON.stringify(data));
        } else {
            state.platformUserId = '';
            state.platformToken = '';
            state.platformUserData = {};
        }
    },
    },
    actions: {
        //退出登录
        PlatformUserLogOut({ commit }) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await PlatformApi.userLogOut()
                    if (response.success) {
                        console.log('前端登出-成功')
                        commit('SET_PLATFORM_AUTH_USER_META');
                        resolve();
                    } else {
                        reject(error);
                    }
                } catch (error) {
                    console.error(error)
                    reject(error);
                }
            });
        },
        //设置登录后的信息
        setLoginPlatformUserMeta({ commit, dispatch }, data) {
            console.log('setLoginPlatformUserMeta:平台用户登录:'+JSON.stringify(data))
            return new Promise(async (resolve, reject) => {
                try {
                    if(!baseUtils.isNull(data)){
                        //设置用户信息
                        commit('SET_PLATFORM_AUTH_USER_META', data);
                        resolve(data);
                    }else{
                        reject(data);
                    }
                } catch (error) {
                    reject(error);
                }
            });
        },
    }
};
export default platformUser;



// WEBPACK FOOTER //
// ./src/store/modules/platformUser.js